var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 7.71429L10.5282 11.0088L10.5297 11.01C11.0572 11.3652 11.3211 11.5429 11.6101 11.6116C11.8656 11.6723 12.1342 11.6723 12.3896 11.6116C12.6789 11.5429 12.9436 11.3646 13.472 11.0088C13.472 11.0088 16.519 8.86139 18.2222 7.71429M5 14.7144V9.28585C5 8.48578 5 8.08544 5.16955 7.77985C5.31868 7.51105 5.55648 7.29267 5.84918 7.1557C6.18193 7 6.61785 7 7.48904 7H16.5113C17.3825 7 17.8174 7 18.1502 7.1557C18.4429 7.29267 18.6815 7.51105 18.8306 7.77985C19 8.08514 19 8.485 19 9.28351V14.7168C19 15.5154 19 15.9146 18.8306 16.2199C18.6815 16.4887 18.4429 16.7075 18.1502 16.8444C17.8178 17 17.383 17 16.5135 17H7.48649C6.617 17 6.1816 17 5.84918 16.8444C5.55648 16.7075 5.31868 16.4887 5.16955 16.2199C5 15.9143 5 15.5145 5 14.7144Z",
    stroke: "#09010F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.69301990996c047110a994d11e532eab.svg";
export { ForwardRef as ReactComponent };